"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

exports.__esModule = true;

var react_1 = __importDefault(require("react"));

exports.SVG = function () {
  return react_1["default"].createElement("svg", {
    viewBox: "0 0 20 20",
    fill: "none"
  }, react_1["default"].createElement("path", {
    d: "M10.795 12.142L8.758 9.969L4.783 12.142L9.155 7.5L11.242 9.673L15.168 7.5L10.795 12.142ZM10 2C5.582 2 2 5.582 2 10C2 14.418 5.582 18 10 18C14.419 18 18 14.418 18 10C18 5.582 14.419 2 10 2Z",
    fill: "#727B7F"
  }));
};